import { MovimientosActuales } from "../../MovimientosActuales";

export const MovimientosActualesRestaurante = () => {
  return <MovimientosActuales hotel={false} restaurante={true} titulo="Movimientos Actuales - Restaurante" />;
};
